import React from 'react';
import {
    NavLink,
    Link
} from 'react-router-dom'

import Logo from './../inc/Logo';
import LogoSVG from './../inc/LogoSVG';

class Header extends React.Component {	
    constructor(props){
        super(props);
        this.handleClick = this.handleClick.bind(this);
        document.getElementsByTagName('html')[0].classList.remove('bound');
		document.getElementsByTagName('html')[0].classList.remove('menu-open');
    }
   
    handleClick(e){
        const root = document.getElementsByTagName('html')[0];
        root.classList.toggle('bound');
        root.classList.toggle('menu-open');
    }

    render() {
        // let {options}   = this.props.options;
        // let logoStyle   = this.props.noLogo ? {visibility:'hidden'} : {};
        // let bgColor     = this.props.bgColor ? {backgroundColor:this.props.bgColor} : {};
        let headerTheme     = this.props.headerTheme ? this.props.headerTheme : '';
        let headerPos     = this.props.headerPos ? this.props.headerPos : '';

        return (
            <header className={`${headerTheme} ${headerPos}`}>
                <div className="main-container">
                    <div className="inner-container">
                        {/* logo */}
                        <Link to={`${process.env.PUBLIC_URL}/`} className="mole-logo">
                            <LogoSVG/>
                        </Link>

                        {
                             /* for fullpage */
                            this.props.fullpage &&
                            <label className="btn-menu--label" htmlFor="btn--menuToggle"></label>
                        }
                        {
                            /* for normal page */
                            !this.props.fullpage &&
                            <a href="javascript:" className="btn-menu" onClick={this.handleClick}/>
                        }
                    </div>
                </div>
            </header>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/inc/Header.js